import { useState } from 'react';
import HeroPage from './HeroPage';
import MenuPage from './MenuPage';

function App() {
  const [page, setPage] = useState('hero');

  return (
    <div style={{ margin: 0, padding: 0 }}>
      {page === 'hero' && <HeroPage onStart={() => setPage('menu')} />}
      {page === 'menu' && <MenuPage onBack={() => setPage('hero')} />}
    </div>
  );
}

export default App;